import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=1afb0d91&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb0d91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1afb0d91')) {
      api.createRecord('1afb0d91', component.options)
    } else {
      api.reload('1afb0d91', component.options)
    }
    module.hot.accept("./Alert.vue?vue&type=template&id=1afb0d91&scoped=true", function () {
      api.rerender('1afb0d91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/Alert.vue"
export default component.exports